import React from 'react';

class AlertPrepayment extends React.Component {
  render() {
    return (
      <div className="alert alert-info" role="alert">
        Для попадания в основу необходимо внести предоплату. Спасибо. <br/><br/>
        <i> С вопросами по турнирам обращайтесь к </i> <a className="payment-info" rel="nofollow" href="https://vk.com/sportey">Александру</a>!
      </div>
    )
  }
}

export default AlertPrepayment;
